// src/utils/tzutils.ts

export function formatTimestampUTC(ts: string, dateOnly: boolean = false): string {
  const date = new Date(ts);
  return dateOnly ? date.toISOString().slice(0, 10) : date.toISOString();
}

export function getUTCTimeParts(ts: string): string {
  const d = new Date(ts);
  return `${d.getUTCHours()}:${d.getUTCMinutes()}:${d.getUTCSeconds()}`;
}

export function allTimestampsSameTimeUTC(timestamps: string[]): boolean {
  if (timestamps.length === 0) return false;
  const firstTimePart = getUTCTimeParts(timestamps[0]);
  return timestamps.every((ts) => getUTCTimeParts(ts) === firstTimePart);
}

export function formatTimestampInTimezone(ts: string, timeZone: string, dateOnly = false): string {
  const date = new Date(ts);
  return new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(dateOnly ? {} : { hour: '2-digit', minute: '2-digit', hour12: false })
  }).format(date);
}

export function formatTimestampByBarType(ts: string, barType: string, timeZone: string): string {
  const date = new Date(ts);

  const opts: Intl.DateTimeFormatOptions = { timeZone };

  if (barType === 'year') {
    opts.year = 'numeric';
  } else if (barType === 'month') {
    opts.year = 'numeric';
    opts.month = '2-digit';
  } else if (barType === 'week' || barType === 'day') {
    opts.year = 'numeric';
    opts.month = '2-digit';
    opts.day = '2-digit';
  } else {
    opts.year = 'numeric';
    opts.month = '2-digit';
    opts.day = '2-digit';
    opts.hour = '2-digit';
    opts.minute = '2-digit';
    opts.hour12 = false;
  }

  return new Intl.DateTimeFormat('en-US', opts).format(date);
}